










import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component
export default class CustomInputPhone extends Vue {
  @Prop() value?: string | undefined;
  @Prop() placeholder?: string;
  @Prop({ default: "+# (###) ###-##-##" }) mask?: string;
  body: string | undefined = "";
  formatted: string | undefined = "";

  rawPhone(str: string | undefined) {
    return str ? str.replace(/[^\d]/g, "") : undefined;
  }

  fixFirstSymbol(val: string) {
    const arr = val?.split("");
    if (arr?.length > 1 && arr[1] !== "7") {
      arr[1] = "7";
    }
    return arr?.length ? arr?.join("") : val;
  }

  @Watch("body")
  changeBody() {
    this.formatted = this.rawPhone(this.body);
    this.$emit("input", this.formatted);
  }

  @Watch("value")
  updateBody() {
    this.body =
      this.rawPhone(this.body) !== this.rawPhone(this.value)
        ? this.value
        : this.body;
  }

  created() {
    this.body = this.value ? this.value : this.body;
  }
}
